module.exports = __webpack_public_path__ + "img/jpg-lijigoumai@2x.2965820a.png";